"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3429],{

/***/ 43429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdf_BulkLinkCopySection; }
});

// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ./hooks/useCheckUpdatingFile.tsx
var useCheckUpdatingFile = __webpack_require__(91837);
// EXTERNAL MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/index.tsx + 6 modules
var EditButton = __webpack_require__(17287);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkEditCtaBanner/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etrm2ap1"
} : 0)( true ? {
  name: "1g74p6e",
  styles: "position:relative;overflow:hidden;width:100%;border-radius:8px;&.background-black{background-color:black;}"
} : 0);
var TextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "etrm2ap0"
} : 0)("z-index:", zIndex/* Z_INDEX.onTop */.k.onTop, ";width:100%;height:100%;&:hover{cursor:pointer;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkEditCtaBanner/index.tsx













var BulkEditCtaBanner = function BulkEditCtaBanner(_ref) {
  var _router$query, _userInfo$subscriptio, _userInfo$subscriptio2;

  var fileName = _ref.fileName,
      fileThumbnail = _ref.fileThumbnail;

  var _useState = (0,react.useState)(false),
      imageLoad = _useState[0],
      setImageLoad = _useState[1];

  var router = (0,next_router.useRouter)();
  var fileId = Number((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.fileId);

  var _useCheckUpdatingFile = (0,useCheckUpdatingFile/* default */.Z)(),
      isDisabled = _useCheckUpdatingFile.isDisabled,
      handleDisabledButtonClick = _useCheckUpdatingFile.handleDisabledButtonClick;

  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  var userPlan = (_userInfo$subscriptio = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio2 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio2 === void 0 ? void 0 : _userInfo$subscriptio2.name) !== null && _userInfo$subscriptio !== void 0 ? _userInfo$subscriptio : 'Free';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.Z, {
    fileId: Number(fileId),
    isDisabled: isDisabled,
    userPlan: userPlan,
    fileName: fileName,
    fileThumbnail: fileThumbnail,
    handleDisabledButtonClick: handleDisabledButtonClick,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      className: classnames_default()({
        'background-black': !imageLoad
      }),
      onClick: function onClick(e) {
        return handleDisabledButtonClick(e);
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWrapper, {
        padding: 24,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 4,
          direction: "column",
          width: "100%",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            color: "zinc_200",
            children: ["\uC774\uBBF8 \uACF5\uC720\uD55C PDF \uCF58\uD150\uCE20\uB97C", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uB9C1\uD06C \uC8FC\uC18C \uBCC0\uACBD \uC5C6\uC774 \uC5C5\uB370\uC774\uD2B8\uB97C \uD574\uBCF4\uC138\uC694"]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "xl-bold",
            color: "white",
            children: "PDF \uC218\uC815\uD558\uAE30"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
          justifyContent: "center",
          alignItems: "center",
          width: "fit-content",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:caret-right",
            size: 24,
            color: "white"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: "/images/banner/cta-banner-background.png",
        layout: "fill",
        objectFit: "fill",
        onLoadingComplete: function onLoadingComplete() {
          return setImageLoad(true);
        }
      })]
    })
  });
};

/* harmony default export */ var BulkLinkCopySection_BulkEditCtaBanner = (BulkEditCtaBanner);
// EXTERNAL MODULE: ./components/User/_components/common/banner/ProPlanUpgradeBanner/index.tsx + 1 modules
var ProPlanUpgradeBanner = __webpack_require__(25030);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkCtaBanner/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4l1tmb1"
} : 0)( true ? {
  name: "1g74p6e",
  styles: "position:relative;overflow:hidden;width:100%;border-radius:8px;&.background-black{background-color:black;}"
} : 0);
var index_styles_TextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e4l1tmb0"
} : 0)("z-index:", zIndex/* Z_INDEX.onTop */.k.onTop, ";width:100%;height:100%;&:hover{cursor:pointer;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkCtaBanner/index.tsx











var BulkCtaBanner = function BulkCtaBanner() {
  var _useState = (0,react.useState)(false),
      imageLoad = _useState[0],
      setImageLoad = _useState[1];

  var router = (0,next_router.useRouter)();
  var fileId = router.query.fileId;

  var _useCheckUpdatingFile = (0,useCheckUpdatingFile/* default */.Z)(),
      handleDisabledButtonClick = _useCheckUpdatingFile.handleDisabledButtonClick;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: "/user/pdf/share-setting?fileId=".concat(fileId),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_Container, {
      className: classnames_default()({
        'background-black': !imageLoad
      }),
      onClick: function onClick(e) {
        return handleDisabledButtonClick(e);
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles_TextWrapper, {
        padding: 24,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 4,
          direction: "column",
          width: "100%",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            color: "zinc_200",
            children: ["\uBB38\uC758\uC591\uC2DD\uC5D0 \uC774\uBA54\uC77C \uC778\uC99D\uC744 \uD65C\uC131\uD654\uD558\uACE0,", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC2A4\uD338 \uC751\uB2F5\uC744 \uC904\uC5EC\uBCF4\uC138\uC694."]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "xl-bold",
            color: "white",
            children: "\uC774\uBA54\uC77C \uC778\uC99D \uC124\uC815\uD558\uAE30"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
          justifyContent: "center",
          alignItems: "center",
          width: "fit-content",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:caret-right",
            size: 24,
            color: "white"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: "/images/banner/form-banner.png",
        layout: "fill",
        objectFit: "fill",
        onLoadingComplete: function onLoadingComplete() {
          return setImageLoad(true);
        },
        unoptimized: true
      })]
    })
  });
};

/* harmony default export */ var BulkLinkCopySection_BulkCtaBanner = (BulkCtaBanner);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-accordion/dist/index.mjs + 1 modules
var dist = __webpack_require__(75694);
// EXTERNAL MODULE: ./styles/keyframes/slide.ts
var slide = __webpack_require__(77991);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/index.styles.ts


function BulkLinkCopySection_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var AccordionRoot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Root */.fC,  true ? {
  target: "e5juixb6"
} : 0)("border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";margin-top:16px;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:8px;" + ( true ? "" : 0));
var AccordionItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Item */.ck,  true ? {
  target: "e5juixb5"
} : 0)("border-bottom:1px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_200;
}, ";&:last-of-type{border-bottom:none;}" + ( true ? "" : 0));
var AccordionTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Trigger */.xz,  true ? {
  target: "e5juixb4"
} : 0)( true ? {
  name: "1qdw41o",
  styles: "display:flex;width:100%;align-items:center;justify-content:space-between;padding:16px"
} : 0);
var AccordionContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Content */.VY,  true ? {
  target: "e5juixb3"
} : 0)("padding:0 16px 16px;&[data-state='closed']{animation:", (0,slide/* slideUp */.i)('var(--radix-collapsible-content-height)'), " 0.15s ease-in-out;}&[data-state='open']{display:flex;flex-direction:column;animation:", (0,slide/* slideDown */.q)('var(--radix-collapsible-content-height)'), " 0.15s ease-in-out;gap:8px;}" + ( true ? "" : 0));
var Ol = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ol",  true ? {
  target: "e5juixb2"
} : 0)( true ? {
  name: "1dh396g",
  styles: "display:flex;flex-direction:column;padding-left:16px;gap:8px"
} : 0);
var Li = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e5juixb1"
} : 0)("height:", function (_ref4) {
  var _ref5;

  var height = _ref4.height;
  return (_ref5 = "".concat(height, "px")) !== null && _ref5 !== void 0 ? _ref5 : 'auto';
}, ";&::marker{color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.black;
}, ";font-size:14px;font-weight:500;line-height:17px;}" + ( true ? "" : 0));
var A = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e5juixb0"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);
// EXTERNAL MODULE: ./styles/Accordion/ViewHistoryAccordion.styles.ts
var ViewHistoryAccordion_styles = __webpack_require__(98862);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLogos/index.constants.ts
var logo = {
  stibee: {
    src: '/images/stibee_logo.png',
    alt: 'Stibee, 스티비 로고',
    width: 86,
    height: 19
  },
  mailchimp: {
    src: '/images/mailchimp_logo.png',
    alt: 'Mailchimp, 메일침프 로고',
    width: 68,
    height: 17
  },
  gmail: {
    src: '/images/gmail_logo.png',
    alt: 'Gmail, 지메일 로고',
    width: 23,
    height: 17
  },
  gmailWithText: {
    src: '/images/gmail_logo_with_text.png',
    alt: 'Gmail, 지메일 로고',
    width: 90,
    height: 19
  },
  activeCampaign: {
    src: '/images/activeCampaign_logo.png',
    alt: 'ActiveCampaign, 액티브캠페인 로고',
    width: 168,
    height: 17
  },
  totle: {
    src: '/images/totle_logo.png',
    alt: 'totle, 토틀 로고',
    width: 57,
    height: 19
  },
  hubspot: {
    src: '/images/hubspot_logo.png',
    alt: 'Hubspot, 허브스팟 로고',
    width: 66,
    height: 19
  },
  salesforcePardot: {
    src: '/images/salesforcePardot_logo.png',
    alt: 'Salesforce Pardot, 솔레스포스 파드트 로고',
    width: 120,
    height: 46
  }
};
var logos = [[logo.stibee, logo.mailchimp, logo.gmail], [logo.activeCampaign, logo.hubspot]];
// EXTERNAL MODULE: ../../node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(50381);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
// EXTERNAL MODULE: ./hooks/queries/file/useFile.ts
var useFile = __webpack_require__(73037);
// EXTERNAL MODULE: ./utils/shareLink.ts
var shareLink = __webpack_require__(79629);
// EXTERNAL MODULE: ./hooks/useShareUrl.ts
var useShareUrl = __webpack_require__(52650);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/useCopy.tsx







var copyLinkType = {
  stibee: '?email=$%email%$',
  mailchimp: '?email=*|EMAIL|*',
  hubspot: '?email={{contact.email}}',
  salesforce: '?email={{Recipient.Email}}',
  activeCampaign: '?email=%EMAIL%',
  totle: '?email=m_email',
  gmail: '?email={{Email}}',
  none: ''
};

var useCopy = function useCopy() {
  var router = (0,next_router.useRouter)();
  var fileId = Number(router.query.fileId);

  var _useFile = (0,useFile/* default */.Z)({
    fileId: fileId
  }, {
    enabled: Boolean(fileId),
    select: function select(data) {
      return data.data.data.file.hashId;
    }
  }),
      hashId = _useFile.data;

  var toast = (0,src/* useToast */.pm)();

  var _useShareUrl = (0,useShareUrl/* default */.Z)({
    targetType: 'BULK_FILE',
    identifier: hashId !== null && hashId !== void 0 ? hashId : ''
  }),
      shareUrl = _useShareUrl.url;

  var copyLink = (0,react.useCallback)(function () {
    var linkType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'none';

    if (hashId) {
      /* ESP 머지태그($%email%$, {{Email}} 등)는 인코딩되면 안 되므로
         URL 파서를 쓰지 않고 문자열로 결합한다. */
      copy_to_clipboard_default()((0,shareLink/* appendQuerySuffix */.j_)(shareUrl, copyLinkType[linkType]));
      toast('링크가 복사되었습니다.');
    } else {
      toast.error("\uACF5\uC720 \uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD558\uB294\uB370 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.\n\uC0C8\uB85C\uACE0\uCE68 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.");
    }
  }, [hashId, shareUrl]);
  return copyLink;
};

/* harmony default export */ var BulkLinkCopySection_useCopy = (useCopy);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/Totle/index.tsx











var Totle = function Totle() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.totle.src,
          alt: logo.totle.alt,
          width: logo.totle.width,
          height: logo.totle.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewHistoryAccordion_styles/* TriggerChevronIcon */.LG, {
          icon: "ph:caret-up",
          size: 19
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionContent, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Ol, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            children: "\uBA54\uC77C \uBCF4\uB0BC \uACE0\uAC1D\uC744 outlook \uC5F0\uB77D\uCC98\uC5D0 \uB4F1\uB85D\uD558\uAE30"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            children: "\uBC1C\uC1A1\uC635\uC158 \u2192 \uB9E4\uD06C\uB85C \uBC1C\uC1A1 \uC744 \uC120\uD0DD\uD558\uAE30"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            as: "button",
            onClick: function onClick() {
              return copy('totle');
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:link",
              size: 17,
              color: "skyblue_400"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              as: "p",
              variant: "md-medium",
              color: "skyblue_400",
              marginLeft: 4,
              children: ["totle\uC6A9 \uB9C1\uD06C", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "md-medium",
                marginLeft: 4,
                children: "\uBA54\uC77C \uBCF8\uBB38\uC5D0 \uBD99\uC5EC\uB123\uAE30"
              })]
            })]
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        marginTop: 16,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('totle');
        },
        children: "totle\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })]
    })]
  });
};

/* harmony default export */ var BulkLinkCopyAccordion_Totle = (Totle);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/Stibee/index.tsx











var Stibee = function Stibee() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.stibee.src,
          alt: logo.stibee.alt,
          width: logo.stibee.width,
          height: logo.stibee.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewHistoryAccordion_styles/* TriggerChevronIcon */.LG, {
          icon: "ph:caret-up",
          size: 19
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        marginTop: 16,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('stibee');
        },
        children: "Stibee\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })
    })]
  });
};

/* harmony default export */ var BulkLinkCopyAccordion_Stibee = (Stibee);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/MailChimp/index.tsx











var MailChimp = function MailChimp() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.mailchimp.src,
          alt: logo.mailchimp.alt,
          width: logo.mailchimp.width,
          height: logo.mailchimp.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewHistoryAccordion_styles/* TriggerChevronIcon */.LG, {
          icon: "ph:caret-up",
          size: 19
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        marginTop: 16,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('mailchimp');
        },
        children: "MailChimp\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })
    })]
  });
};

/* harmony default export */ var BulkLinkCopyAccordion_MailChimp = (MailChimp);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/HubSpot/index.styles.ts


function HubSpot_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var LinkIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "ef2zugi0"
} : 0)( true ? {
  name: "jbgpyq",
  styles: "transform:rotate(90deg)"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/HubSpot/index.tsx












var HubSpot = function HubSpot() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.hubspot.src,
          alt: logo.hubspot.alt,
          width: logo.hubspot.width,
          height: logo.hubspot.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewHistoryAccordion_styles/* TriggerChevronIcon */.LG, {
          icon: "ph:caret-up",
          size: 19
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionContent, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Ol, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
              as: "button",
              display: "inline-flex",
              onClick: function onClick() {
                return copy('hubspot');
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:link",
                size: 17,
                color: "skyblue_400"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                as: "p",
                variant: "md-medium",
                color: "skyblue_400",
                marginLeft: 4,
                children: "HubSpot\uC6A9 \uB9C1\uD06C"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "div",
              variant: "md-medium",
              marginLeft: 4,
              children: "\uBCF5\uC0AC\uD55C \uB4A4, \uC774\uBA54\uC77C \uCC3D\uC5D0\uC11C"
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
            as: "button",
            onClick: function onClick() {
              return copy('hubspot');
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkIcon, {
                icon: "ph:link-simple-horizontal",
                size: 17
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                as: "div",
                variant: "md-medium",
                marginLeft: 4,
                children: "(Insert link) \uB610\uB294 \uBC84\uD2BC\uC5D0 \uC0BD\uC785\uD558\uAE30"
              })]
            })
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        marginTop: 16,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('hubspot');
        },
        children: "HubSpot\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })]
    })]
  });
};

/* harmony default export */ var BulkLinkCopyAccordion_HubSpot = (HubSpot);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/ActiveCampaign/index.tsx











var ActiveCampaign = function ActiveCampaign() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.activeCampaign.src,
          alt: logo.activeCampaign.alt,
          width: logo.activeCampaign.width,
          height: logo.activeCampaign.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewHistoryAccordion_styles/* TriggerChevronIcon */.LG, {
          icon: "ph:caret-up",
          size: 19
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        marginTop: 16,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('activeCampaign');
        },
        children: "ActiveCampaign\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })
    })]
  });
};

/* harmony default export */ var BulkLinkCopyAccordion_ActiveCampaign = (ActiveCampaign);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/SalesforcePardot/index.tsx











var SalesforcePardot = function SalesforcePardot() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionTrigger, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.salesforcePardot.src,
          alt: logo.salesforcePardot.alt,
          width: logo.salesforcePardot.width,
          height: logo.salesforcePardot.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ViewHistoryAccordion_styles/* TriggerChevronIcon */.LG, {
          icon: "ph:caret-up",
          size: 19
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        marginTop: 16,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('salesforce');
        },
        children: "Salesforce Pardot\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      })
    })]
  });
};

/* harmony default export */ var BulkLinkCopyAccordion_SalesforcePardot = (SalesforcePardot);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/BulkLinkCopyAccordion/index.tsx










var item = {
  stibee: 'stibee',
  mailchimp: 'mailchimp',
  hubspot: 'hubspot',
  activeCampaign: 'activeCampaign',
  totle: 'totle',
  gmail: 'gmail',
  salesforce: 'salesforce',
  none: 'none'
};

var BulkLinkCopyAccordion = function BulkLinkCopyAccordion() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      as: "p",
      variant: "lg-semibold",
      color: "zinc_500",
      children: "\uB9C8\uCF00\uD305/\uBA54\uC77C \uD50C\uB7AB\uD3FC\uC73C\uB85C \uC790\uB8CC \uBCF4\uB0B4\uACE0 \uC2F6\uC744 \uB550"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionRoot, {
      type: "multiple",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
        value: item.stibee,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopyAccordion_Stibee, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
        value: item.mailchimp,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopyAccordion_MailChimp, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
        value: item.hubspot,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopyAccordion_HubSpot, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
        value: item.activeCampaign,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopyAccordion_ActiveCampaign, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
        value: item.totle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopyAccordion_Totle, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
        value: item.salesforce,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopyAccordion_SalesforcePardot, {})
      })]
    })]
  });
};

/* harmony default export */ var BulkLinkCopySection_BulkLinkCopyAccordion = (BulkLinkCopyAccordion);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/GmailBox/index.styles.ts


var GmailBox_index_styles_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "er55h6h0"
} : 0)("border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:8px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/GmailBox/index.tsx








var GmailBox = function GmailBox() {
  var copy = BulkLinkCopySection_useCopy();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 8,
    direction: "column",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 4,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 2,
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: logo.gmailWithText.src,
          alt: logo.gmailWithText.alt,
          width: logo.gmailWithText.width,
          height: logo.gmailWithText.height
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-semibold",
          color: "zinc_500",
          children: "\uB85C \uC5EC\uB7EC \uC0AC\uB78C\uC5D0\uAC8C \uC790\uB8CC\uB97C \uBCF4\uB0BC \uB550"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-medium",
        color: "zinc_400",
        children: "\u2018\uCCA8\uBD80 \uD30C\uC77C\u2019 \uB300\uC2E0 \uBA54\uC77C \uBCF8\uBB38\uC5D0 \uC138\uC77C\uC988\uD074\uB8E8 \uB9C1\uD06C\uB97C \uBD99\uC5EC\uB123\uC73C\uC138\uC694."
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GmailBox_index_styles_Container, {
      gap: 16,
      padding: 16,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 8,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            target: "_blank",
            href: "https://docs.google.com/spreadsheets/d/1mEGwwD41n59Kr6jZ5cLMfV_txF4KZRYyCZJhtwTQpmQ/copy?usp=sharing",
            rel: "noreferrer noopener nofollow",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
              as: "button",
              alignItems: "center",
              justifyContent: "center",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "md-medium",
                as: "p",
                paddingRight: 4,
                children: "1."
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:file-text",
                size: 17,
                color: "skyblue_400"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                as: "p",
                variant: "md-medium",
                color: "skyblue_400",
                marginLeft: 4,
                children: "\uC2A4\uD504\uB808\uB4DC \uC2DC\uD2B8"
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-medium",
            marginLeft: 4,
            children: "\uC5F4\uC5B4 \u2018\uC0AC\uBCF8 \uB9CC\uB4E4\uAE30\u2019 \uD074\uB9AD\uD558\uAE30"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            as: "p",
            paddingRight: 4,
            children: "2."
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-medium",
            children: "\uC2DC\uD2B8 \uB0B4 \uACE0\uAC1D \uC815\uBCF4 \uC785\uB825\uD558\uAE30"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
            as: "button",
            display: "inline-flex",
            onClick: function onClick() {
              return copy('gmail');
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "md-medium",
              as: "p",
              paddingRight: 4,
              children: "3."
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:link",
              size: 17,
              color: "skyblue_400"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              as: "p",
              variant: "md-medium",
              color: "skyblue_400",
              marginLeft: 4,
              children: "Gmail\uC6A9 \uB9C1\uD06C"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-medium",
            marginLeft: 4,
            children: "\uBA54\uC77C \uBCF8\uBB38\uC5D0 \uBD99\uC5EC\uB123\uAE30"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            as: "p",
            paddingRight: 4,
            children: "4."
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            as: "p",
            variant: "md-medium",
            children: "\uC2A4\uD504\uB808\uB4DC \uC2DC\uD2B8\uC5D0\uC11C \u201CMail Merge\u201C \uD074\uB9AD\uD574 \uC804\uC1A1\uD558\uAE30"
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        type: "button",
        width: "100%",
        variant: "skyblue_300",
        textVariant: "md-medium",
        radius: 8,
        paddingX: 16,
        paddingY: 12,
        InnerWrappeGap: 4,
        leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
          icon: "ph:link",
          size: 17
        }),
        onClick: function onClick() {
          return copy('gmail');
        },
        children: "Gmail\uC6A9 \uB9C1\uD06C \uC0DD\uC131\uD558\uAE30"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
        justifyContent: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: "https://www.sclu.io/share/link/b80c0b87d965e3cd",
          target: "_blank",
          rel: "noreferrer noopener nofollow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            gap: 8,
            justifyContent: "center",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "md-medium",
              color: "skyblue_400",
              marginRight: 8,
              children: "\uC790\uC138\uD55C \uAC00\uC774\uB4DC \uBCF4\uAE30"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-right",
              color: "skyblue_400",
              size: 17
            })]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var BulkLinkCopySection_GmailBox = (GmailBox);
;// CONCATENATED MODULE: ./components/User/_components/pdf/BulkLinkCopySection/index.tsx









var BulkLinkCopySection = function BulkLinkCopySection(_ref) {
  var fileName = _ref.fileName,
      fileThumbnail = _ref.fileThumbnail,
      _ref$isShowBanner = _ref.isShowBanner,
      isShowBanner = _ref$isShowBanner === void 0 ? false : _ref$isShowBanner;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 32,
    direction: "column",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: [fileName && fileThumbnail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopySection_BulkEditCtaBanner, {
        fileName: fileName,
        fileThumbnail: fileThumbnail
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopySection_BulkCtaBanner, {})]
    }), isShowBanner && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeBanner/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopySection_GmailBox, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BulkLinkCopySection_BulkLinkCopyAccordion, {})]
  });
};

/* harmony default export */ var pdf_BulkLinkCopySection = (BulkLinkCopySection);

/***/ })

}]);